export default {
    dependencies: ['$element', 'trackingservice'],
    callable(el, trackingService) {
        const entryPoint = el.getAttribute('data-entry-point');

        el.addEventListener('click', () => {
            trackingService.trackEventObject({
                analyticsName: 'promotion.go-to-app-store.click',
                eventFlags: 'start,ltp',
                stringValue: entryPoint,
            });
        });
    },
};



// WEBPACK FOOTER //
// ./controllers/trackAppPromotion.js